<template>
    <div class="center">
     <div class="header2" v-if="isDetails">
         <van-nav-bar
            :title="title"
            left-text="返回"
            left-arrow
            @click-left="goBack"
            />
     </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isIndex:true,
            isDetails:false,
            // isDetails2:false,
            title:'',
            headerimg:require('./../assets/img/header.png'),
            userName:'未登录'
        }
    },
    watch:{
      $route(){
        this.getRoute()
      }
    },
    mounted(){
        this.getRoute()
        this.userName=localStorage.getItem("nickname")
        this.headerimg=localStorage.getItem("headimgurl")
    },
    methods:{
        getRoute(){
        let pathName=this.$route.path
        if(pathName.indexOf('details')>=0){
        this.isDetails=true
        this.isDetails2=false
        this.isIndex=false
        this.title=this.$route.name
        }
        if (this.$route.query.show==1){
          this.isDetails=false
        }
      },
      goBack(){
        this.$router.go(-1)
      }
    }
}
</script>
<style scoped>
.header{
    /* width: 95%; */
    height: 70px;
    display: flex;
    align-items: center;
    /* background: #3084B0; */
    background: #037af2;
    color: #fff;
    /* border: 1px solid; */
}
.header2 >>> .van-nav-bar__content{
    height: 70px;
}
.image{
    width: 50px;
    height: 50px;
    margin-left: 10px;
    border-radius: 50%;
}
.text{
    display: block;
    padding-left: 10px;
    line-height: 50px;
    font-size: 0.3rem;
}
/* .header2 >>> .van-icon , .header2 >>> .van-nav-bar__text{
    color: #fc6e09 ;
} */
</style>
